<template>
  <svg
    width="42"
    height="41"
    viewBox="0 0 42 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="32.2338"
      cy="23.5"
      r="9.5"
      fill="var(--icon-secondary, #43386040)"
    />
    <path
      d="M6.74551 28.2052C6.74551 28.2052 11.8409 23.3189 13.0444 21.7733C13.4971 21.1873 15.5568 18.8639 11.5979 11.4584"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.2238 26.168C22.2238 26.168 25.5115 24.5514 28.3264 20.6816"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.8829 22.4748C20.8829 22.4748 23.2093 21.4299 25.9071 17.8852"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.2832 28.7117C25.2832 28.7117 27.3126 27.6997 29.4792 25.0418"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.7532 31.5805C21.5943 32.7112 17.169 34.3036 13.6114 31.5806"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8347 19.1532C19.8919 18.4601 22.1883 16.1987 23.9561 14.2838C26.9024 11.0924 29.9526 9.59643 30.3902 9.68744"
      stroke="var(--icon-primary, var(--grey800))"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5571 5.797L19.2338 2L17.9105 5.797L13.7338 7L17.9105 8.203L19.2338 12L20.5571 8.203L24.7338 7L20.5571 5.797Z"
      fill="var(--icon-primary, var(--grey800))"
      fill-opacity="0.25"
    />
  </svg>
</template>
